export default {
  // Header Section
  "discover_your": "உங்கள்",
  "lal_kitab": "லால் கிதாப்",
  "ancient_remedial_wisdom": "பண்டைய பரிகார ஞானம்",
  "lal_kitab_description": "தனிப்பயன் லால் கிதாப் பகுப்பாய்வுடன் பண்டைய ஞானத்தின் உலகிற்குள் நுழையுங்கள். மறைந்துள்ள கர்ம முறைபாடுகளை வெளிக்கொண்டு, வாழ்க்கையின் ரகசியங்களை அறிந்து, சவால்களை வெற்றி, ஒற்றுமை மற்றும் வளமாக மாற்றும் எளிய ஆனால் சக்திவாய்ந்த பரிகாரங்களைப் பெறுங்கள்.",

  "lal_kitab_title": "லால் கிதாபுடன்",
  "craft_your_destiny": "உங்கள் விதியை உருவாக்குங்கள்",

  // Service Information
  "enter_details_for_lal_kitab": "லால் கிதாப் பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_lal_kitab_analysis": "முழுமையான லால் கிதாப் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_lal_kitab_analysis_note": "நடைமுறை பரிகாரங்கள் மற்றும் கர்ம வழிகாட்டுதலுடன் கூடிய விரிவான லால் கிதாப் சார்ட் பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_lal_kitab_influence": "லால் கிதாபில் உங்கள் பெயர், கர்ம முறைபாடுகளையும் பரிகார விளைவைவும் பாதிக்கலாம்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_lal_kitab_chart": "துல்லியமான லால் கிதாப் சார்ட் மற்றும் கிரக பகுப்பாய்வு உருவாக்க இவை அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_lal_kitab_houses": "லால் கிதாப் முறையில் வீட்டு நிலைகளை துல்லியமாக அமைக்க சரியான நேரம் தேவை",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_lal_kitab_analysis": "இடம், கிரக நிலைகள் மற்றும் லால் கிதாப் கணக்கீடுகளில் தாக்கம் செலுத்துகிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் லால் கிதாப் பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Lal Kitab Features
  "lal_kitab_chart_analysis": "லால் கிதாப் சார்ட் பகுப்பாய்வு",
  "planetary_positions_lal_kitab": "லால் கிதாபில் கிரக நிலைகள்",
  "practical_remedies_solutions": "நடைமுறை பரிகாரங்கள் & தீர்வுகள்",
  "karmic_debts_analysis": "கர்ம கடன்கள் பகுப்பாய்வு",
  "life_predictions_guidance": "வாழ்க்கை முன்கணிப்புகள் & வழிகாட்டுதல்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் லால் கிதாப் பகுப்பாய்வில் உள்ளவை",
  "complete_lal_kitab_chart": "முழுமையான லால் கிதாப் சார்ட்",
  "practical_remedial_measures": "நடைமுறை பரிகார முறைகள்",
  "karmic_analysis_guidance": "கர்ம பகுப்பாய்வு & வழிகாட்டுதல்",
  "life_predictions_insights": "வாழ்க்கை முன்கணிப்பு நுண்ணறிவுகள்",

  // Actions & Buttons
  "pay_and_get_lal_kitab_analysis": "என் லால் கிதாப் பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "lal_kitab_analysis_processing": "உங்கள் முழுமையான லால் கிதாப் பகுப்பாய்வை எங்கள் நிபுணர் லால் கிதாப் ஜோதிடர்கள் தயாரித்து வருகின்றனர். நடைமுறை பரிகாரங்களும் கர்ம நுண்ணறிவுகளும் கொண்ட விரிவான சார்ட் பகுப்பாய்வு வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_24_hours_delivery_note": "உங்கள் விரிவான லால் கிதாப் பகுப்பாய்வு 24 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் லால் கிதாப் பகுப்பாய்வு தொகுப்பு",
  "detailed_lal_kitab_report": "விரிவான லால் கிதாப் அறிக்கை (PDF)",
  "lal_kitab_chart_analysis_item": "லால் கிதாப் சார்ட் பகுப்பாய்வு",
  "practical_remedies_list": "நடைமுறை பரிகார பட்டியல்",
  "karmic_debts_solutions": "கர்ம கடன்கள் & தீர்வுகள்",
  "life_guidance_predictions": "வாழ்க்கை வழிகாட்டுதல் & முன்கணிப்புகள்",

  // Visual Content
  "sample_lal_kitab_analysis": "மாதிரி லால் கிதாப் பகுப்பாய்வு",
  "lal_kitab_house_analysis": "லால் கிதாப் வீட்டு பகுப்பாய்வு",
  "sample_lal_kitab_reading": "வலுவான கிரக நிலைகள் — நடைமுறை பரிகாரத் தீர்வுகளுடன்",
  "sample_lal_kitab_preview": "பரிகார வழிகாட்டுதலுடன் உங்கள் தனிப்பயன் லால் கிதாப் பகுப்பாய்வின் முன்னோட்டம்",
  "lal_kitab_houses": "லால் கிதாப் வீடுகள்",

  // House Types
  "self": "தன்மை/நான்",
  "wealth": "செல்வம்",
  "siblings": "உடன்பிறப்புகள்",
  "mother": "தாய்",
  "children": "மக்கள்/சந்ததி",
  "enemies": "விரோதிகள்",
  "spouse": "துணைவர்",
  "longevity": "ஆயுட்காலம்",
  "father": "தந்தை",
  "career": "தொழில்",
  "gains": "லாபம்",
  "expenses": "செலவுகள்",

  // Status & Processing
  "your_lal_kitab_analysis_status": "உங்கள் லால் கிதாப் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் லால் கிதாப் சார்ட் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "துல்லியமான பகுப்பாய்வு, நடைமுறை பரிகாரங்கள் மற்றும் கர்ம நுண்ணறிவுகளுக்காக உங்கள் ஜாதகம் ஆய்வு செய்யப்படுகிறது.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_24_hours": "அறிக்கை 24 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "லால் கிதாப் ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Lal Kitab Specific Elements
  "planetary_debts": "கிரகக் கடன்கள்",
  "karmic_accounts": "கர்மக் கணக்குகள்",
  "ancestral_karma": "பித்ரு கர்மா",
  "past_life_debts": "முன் பிறவி கடன்கள்",
  "family_karma": "குடும்ப கர்மா",
  "collective_karma": "கூட்டு கர்மா",

  // Planets in Lal Kitab
  "sun_lal_kitab": "லால் கிதாபில் சூரியன்",
  "moon_lal_kitab": "லால் கிதாபில் சந்திரன்",
  "mars_lal_kitab": "லால் கிதாபில் செவ்வாய்",
  "mercury_lal_kitab": "லால் கிதாபில் புதன்",
  "jupiter_lal_kitab": "லால் கிதாபில் வியாழன்",
  "venus_lal_kitab": "லால் கிதாபில் சுக்கிரன்",
  "saturn_lal_kitab": "லால் கிதாபில் சனி",
  "rahu_lal_kitab": "லால் கிதாபில் ராகு",
  "ketu_lal_kitab": "லால் கிதாபில் கேது",

  // Remedial Categories
  "simple_remedies": "எளிய இல்ல பரிகாரங்கள்",
  "donation_remedies": "தான & தர்ம பரிகாரங்கள்",
  "feeding_remedies": "உணவளிப்பு & சேவை பரிகாரங்கள்",
  "water_remedies": "நீர் சார்ந்த பரிகாரங்கள்",
  "clothing_remedies": "உடை & நிற பரிகாரங்கள்",
  "behavioral_remedies": "நடத்தை மாற்றும் பரிகாரங்கள்",

  // Types of Debts
  "pitra_rin": "பித்ரு ரிண் (மூதாதையர் கடன்)",
  "matru_rin": "மாத்ரு ரிண் (தாய் கடன்)",
  "stree_rin": "ஸ்த்ரீ ரிண் (மனைவி கடன்)",
  "bhratru_rin": "ப்ராத்த்ரு ரிண் (சகோதரன் கடன்)",
  "putra_rin": "புத்திர ரிண் (மகன் கடன்)",
  "guru_rin": "குரு ரிண் (ஆசிரியர் கடன்)",

  // Lal Kitab Concepts
  "blind_planets": "குருட்டுக் கிரகங்கள்",
  "lame_planets": "முடங்கிய கிரகங்கள்",
  "sleeping_planets": "தூங்கும் கிரகங்கள்",
  "deceased_planets": "மறைந்த கிரகங்கள்",
  "enemy_planets": "எதிரி கிரகங்கள்",
  "friend_planets": "நண்பர் கிரகங்கள்",

  // House Analysis
  "first_house": "1ஆம் வீடு - தன்மை & நான்",
  "second_house": "2ஆம் வீடு - செல்வம் & குடும்பம்",
  "third_house": "3ஆம் வீடு - உடன்பிறப்பு & தொடர்பாடல்",
  "fourth_house": "4ஆம் வீடு - தாய் & சொத்து",
  "fifth_house": "5ஆம் வீடு - பிள்ளைகள் & கல்வி",
  "sixth_house": "6ஆம் வீடு - விரோதிகள் & ஆரோக்கியம்",
  "seventh_house": "7ஆம் வீடு - திருமணம் & கூட்டாண்மை",
  "eighth_house": "8ஆம் வீடு - ஆயுட்காலம் & மறைஞானம்",
  "ninth_house": "9ஆம் வீடு - தந்தை & அதிர்ஷ்டம்",
  "tenth_house": "10ஆம் வீடு - தொழில் & அந்தஸ்து",
  "eleventh_house": "11ஆம் வீடு - லாபம் & நண்பர்கள்",
  "twelfth_house": "12ஆம் வீடு - செலவுகள் & வெளிநாடு",

  // Planetary Strengths
  "strong_planets": "வலுவான கிரகங்கள்",
  "weak_planets": "பலவீன கிரகங்கள்",
  "malefic_planets": "பாப கிரகங்கள்",
  "benefic_planets": "சுப கிரகங்கள்",
  "neutral_planets": "நடுநிலை கிரகங்கள்",
  "exalted_planets": "உச்ச கிரகங்கள்",

  // Remedy Types
  "immediate_remedies": "உடனடி பலன் தரும் பரிகாரங்கள்",
  "long_term_remedies": "நீண்டகால பரிகாரங்கள்",
  "emergency_remedies": "அவசர பரிகாரங்கள்",
  "preventive_remedies": "முன்கூட்டிய பரிகாரங்கள்",
  "corrective_remedies": "சரிசெய்யும் பரிகாரங்கள்",
  "protective_remedies": "பாதுகாப்பளிக்கும் பரிகாரங்கள்",

  // Life Areas Analysis
  "health_analysis": "ஆரோக்கிய பகுப்பாய்வு",
  "wealth_analysis": "செல்வ பகுப்பாய்வு",
  "career_analysis": "தொழில் பகுப்பாய்வு",
  "marriage_analysis": "திருமண பகுப்பாய்வு",
  "children_analysis": "சந்ததி பகுப்பாய்வு",
  "property_analysis": "சொத்து பகுப்பாய்வு",

  // Timing Analysis
  "favorable_periods": "சாதகமான காலங்கள்",
  "challenging_periods": "சவாலான காலங்கள்",
  "remedy_timing": "பரிகாரங்களை செயல்படுத்தும் நேரம்",
  "result_timing": "எதிர்பார்க்கப்படும் பலன் நேரம்",
  "life_phases": "முக்கிய வாழ்க்கைக் கட்டங்கள்",
  "turning_points": "வாழ்க்கை திருப்பங்கள்",

  // Special Features
  "curse_analysis": "சாபம் & எதிர்மறை ஆற்றல் பகுப்பாய்வு",
  "blessing_analysis": "ஆசீர்வாதங்கள் & நேர்மறை ஆற்றல்",
  "family_tree_karma": "குடும்ப மர கர்மா பகுப்பாய்வு",
  "generational_patterns": "தலைமுறை கர்ம முறைபாடுகள்",
  "soul_purpose": "ஆத்தும நோக்கம் & வாழ்க்கை பணி",
  "spiritual_evolution": "ஆன்மீக பரிணாமப் பாதை",

  // Practical Applications
  "daily_remedies": "தினசரி பரிகாரங்கள்",
  "weekly_remedies": "வாராந்திர ஒழுங்குகள்",
  "monthly_remedies": "மாதாந்திர வழிமுறைகள்",
  "annual_remedies": "ஆண்டாந்திர வழிமுறைகள்",
  "special_occasion_remedies": "சிறப்பு நிகழ்ச்சி பரிகாரங்கள்",
  "festival_remedies": "விழாக் கால பரிகாரங்கள்",

  // Modern Adaptations
  "urban_remedies": "நகர வாழ்க்கைக்கான உகப்பு பரிகாரங்கள்",
  "office_remedies": "பணியிடம் பரிகாரங்கள்",
  "travel_remedies": "பயணம் & பயண பரிகாரங்கள்",
  "technology_remedies": "இக்கால தொழில்நுட்ப பரிகாரங்கள்",
  "social_media_remedies": "டிஜிட்டல் யுக பரிகாரங்கள்",
  "global_living_remedies": "சர்வதேச வாழ்வுக்கான உகப்புகள்",

  // Consultation Features
  "expert_consultation": "லால் கிதாப் நிபுணர் ஆலோசனை",
  "follow_up_guidance": "பின்தொடரும் பரிகார வழிகாட்டுதல்",
  "progress_tracking": "பரிகார முன்னேற்றத் கண்காணிப்பு",
  "customization": "தனிப்பயன் பரிகார அமைப்பு",
  "update_analysis": "புதுப்பிப்பு பகுப்பாய்வு விருப்பங்கள்",
  "family_analysis": "குடும்ப சார்ட் பகுப்பாய்வு",

  // Advanced Concepts
  "paap_planets": "பாப (பாவ) கிரகங்கள்",
  "punya_planets": "புண்ய கிரகங்கள்",
  "raja_yoga": "லால் கிதாபில் ராஜயோகம்",
  "dhana_yoga": "தன யோகக் கூட்டிணைப்புகள்",
  "vipreet_raja_yoga": "விபரீத ராஜயோகம்",
  "neech_bhang_yoga": "நீச்ச பங்க யோகம்",

  // Unique Lal Kitab Rules
  "pakka_ghar": "பக்கா கார் (நிலையான வீடு)",
  "kachha_ghar": "கச்சா கார் (தற்காலிக வீடு)",
  "mool_trikona": "லால் கிதாபில் மூலம் திரிகோண",
  "own_house": "சுய வீட்டு நிலை",
  "friendly_house": "நண்பன் வீடு நிலை",
  "enemy_house": "எதிரி வீடு நிலை"
};
